import React from 'react'

import AppleLoginButton, { AppleLoginButtonProps } from '../AppleLogin/AppleLoginButtonView'
import { Button } from '../Button/Button'
import GoogleLoginButton from '../GoogleLoginButton'
import { GoogleLoginButtonProps } from '../GoogleLoginButton/GoogleLoginButtonView'

import styles from './AuthModals.module.css'
import { RegisterSignInCallback } from './RegisterModal/RegisterModalView'

export function ModalTitle({ title }: { title: string }) {
  return <h2 className={styles.title}>{title}</h2>
}

export function NoAccount({
  title,
  buttonProps: { onClick, label },
}: {
  title: string
  buttonProps: { label: string; onClick?: () => void }
}) {
  return (
    <h5 className={styles.noAccount}>
      {title}
      <button type='button' className={styles.noAccountButton} onClick={onClick}>
        {label}
      </button>
    </h5>
  )
}

export function SubmitButton({ disabled, label }: { disabled: boolean; label: string }) {
  return (
    <Button className={styles.button} type='submit' disabled={disabled}>
      {label}
    </Button>
  )
}

export function SocialButtons({
  onLogin,
  googleButtonProps,
  appleButtonProps,
}: {
  onLogin?: RegisterSignInCallback
  googleButtonProps?: GoogleLoginButtonProps
  appleButtonProps?: AppleLoginButtonProps
}) {
  return (
    <div className={styles.otherLoginButtons}>
      <GoogleLoginButton onLogin={onLogin} {...googleButtonProps} />
      <AppleLoginButton onLogin={onLogin} {...appleButtonProps} />
    </div>
  )
}
